module.exports = __webpack_public_path__ + "img/login.1429645d.png";